import getSurfaceStore from '../store/store';
import { mutator } from 'satcheljs';
import { onAgendaViewLoadingStatusChanged } from 'mini-calendar-agenda-store/lib/actions/publicActions';
import { onDayViewLoadingStatusChanged } from 'mini-calendar-dayview-store/lib/actions/publicActions';

const mutateSpinner = ({ isLoading }) => {
    const surfaceStore = getSurfaceStore();
    surfaceStore.showSpinner = isLoading;
};

/**
 * Mutator action to set the spinner state from Day View
 */
export const onDayViewLoadingStatusChangedMutator = mutator(
    onDayViewLoadingStatusChanged,
    mutateSpinner
);

/**
 * Mutator action to set the spinner state from Agenda View
 */
const onAgendaViewLoadingStatusChangedMutator = mutator(
    onAgendaViewLoadingStatusChanged,
    mutateSpinner
);

export default onAgendaViewLoadingStatusChangedMutator;
